function RadioDD({ entries, DDname, active, updateFilterValue, setActive }) {

  return (
    <div className={"select-panel " + (active ? "active" : "")}>
      {entries.map((entry, key) =>
        <div className="inp-group" key={key}>
          <input type="radio" id={entry.value} name={DDname} value={entry.value} onChange={() => {
            updateFilterValue(DDname, entry.value);
            setActive(false);
            }} />
          <label htmlFor={entry.value}>{entry.name}</label>
        </div>
      )}
    </div>
  );
}

export default RadioDD